<template>
  <div class="renewal-price">
    <!-- 已购买 不展示续报价格-->
    <template v-if="status.id === 3">
      <div class="inner-title">{{ status.desc }}</div>
    </template>
    <template v-else>
      <div v-if="!!halt_sale_date && status.id === 1" class="inner-title">
        <span class="price-title" v-html="halt_sale_date"></span>
      </div>
      <div v-else class="inner-title">{{ showDesc ? status.desc : "" }}</div>
      <div class="flex-end-baseline">
        <p class="inner-desc">{{ price.msg }}</p>
        <p class="price">
          <span class="sale-price-char" v-if="showSalePrice">¥</span>
          <span class="sale-price" v-if="showSalePrice">{{ salePrice }}</span>
          <span class="price-name" v-if="showSalePrice">到手价</span>
          <span class="char">¥</span>
          <span class="buy-price">{{ buyPrice }}</span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inject: ["isAddPriceBuy", "listType"],
  props: {
    halt_sale_date: {
      type: [Number, String],
      default: 0,
    },
    status: {
      type: Object,
      default: () => {
        return {};
      },
    },
    price: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectType: {
      type: Number,
    },
  },
  computed: {
    // 状态ID （1、正常状态，2、已报满（无库存），3、已购买，4、已停售，5、需诊断后报名，6、无报名资格，10、诊断未通过，11、待开售）
    showDesc() {
      // 此处的样式只展示非正常和诊断状态
      // 诊断状态由其他组件展示
      return ![1, 5, 10].includes(+this.status?.id);
    },
    salePrice() {
      return this.price?.sale_price; //后端取值逻辑：销售期价格 || 课程原价
    },
    showSalePrice() {
      return +this.salePrice !== +this.buyPrice;
    },
    buyPrice() {
      const { selectType, price } = this;
      const { buy_price } = price || {}; // 加价接口返回的价格
      // 加价购 二级页面 只展示原价
      if (this.isAddPriceBuy && this.listType === "change") {
        return this.salePrice;
      }
      // 商品勾选的情况下使用计价接口返回的价格
      if (+selectType === 2 && (!!buy_price || buy_price === 0)) {
        return buy_price;
      }
      return this.salePrice;
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
@font-face {
  font-family: "DIN";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/DIN-Regular.otf")
    format("opentype");
}
.renewal-price {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 16px;
  padding-left: 4px;
}
.price {
  margin-left: 8px;
  font-family: DIN-Bold-700;
  .sale-price-char {
    position: relative;
    top: 1px;
    margin-right: 1px;
    font-size: 12px;
    color: #999;
  }
  .sale-price {
    position: relative;
    top: 1px;
    margin-right: 8px;
    color: #999;
    text-align: right;
    font-size: 13px;
  }

  .buy-price {
    position: relative;
    top: 1px;
    color: #f93834;
    text-align: right;
    font-size: 19px;
    font-style: normal;
    line-height: normal;
  }

  .price-name {
    margin-right: 2px;
    color: #f93834;
    text-align: right;
    font-size: 11px;
    font-weight: 600;
  }
  .char {
    position: relative;
    top: 1px;
    margin-right: 2px;
    margin-top: 1px;
    color: #f93834;
    text-align: right;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 13px; /* 100% */
  }
}
</style>
<style lang="less">
.price-title {
  span {
    color: red;
  }
}
</style>
